import {
  type DatabaseValue,
  type DatabaseField,
  DatabaseFieldType
} from '@databases/types/database';

import type { GroupableFieldType } from '../grouping.ts';
import { type StateSelectors } from '../state-selectors/state-selectors.ts';

import { DatabaseGroupSelectField } from './database-group-select-field.ts';
import { DatabaseGroupUserField } from './database-group-user-field.ts';
import type { DatabaseGroup } from './database-group.ts';

/** Creates a DatabaseGroup instance of the proper type for a given field. */
export function createDatabaseGroup(
  key: string,
  stateSelectors: StateSelectors,
  groupField: DatabaseField<DatabaseFieldType>,
  fieldValue: DatabaseValue<DatabaseFieldType> | undefined,
  entryId?: string
): DatabaseGroup {
  // Note: must handle all groupable field types here, or TS will complain
  switch (groupField.type as GroupableFieldType) {
    case DatabaseFieldType.SELECT: {
      return new DatabaseGroupSelectField(
        key,
        groupField as DatabaseField<DatabaseFieldType.SELECT>,
        fieldValue as DatabaseValue<DatabaseFieldType.SELECT>,
        entryId
      );
    }
    case DatabaseFieldType.USER: {
      return new DatabaseGroupUserField(
        key,
        stateSelectors.selectUserByIdOptional,
        groupField as DatabaseField<DatabaseFieldType.USER>,
        fieldValue as DatabaseValue<DatabaseFieldType.USER>,
        entryId
      );
    }
  }
}

export function generateGroupKeyForFieldValue(
  groupField: DatabaseField<DatabaseFieldType>,
  fieldValue: DatabaseValue<DatabaseFieldType> | undefined
): string {
  // Note: must handle all groupable field types here, or TS will complain
  switch (groupField.type as GroupableFieldType) {
    case DatabaseFieldType.SELECT: {
      return DatabaseGroupSelectField.generateKeyForFieldValue(
        fieldValue as DatabaseValue<DatabaseFieldType.SELECT>,
        (groupField as DatabaseField<DatabaseFieldType.SELECT>).settings.selectOptions
      );
    }
    case DatabaseFieldType.USER: {
      return DatabaseGroupUserField.generateKeyForFieldValue(
        fieldValue as DatabaseValue<DatabaseFieldType.USER>
      );
    }
  }
}
